(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["canine-back-to-top"]) return;
  try {
    
  (() => {
    const button = document.querySelector('[data-cc-back-to-top]');
    if (!button) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const updateVisibility = () => {
      button.dataset.visible = window.scrollY > 560 ? 'true' : 'false';
    };

    button.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    });

    window.addEventListener('scroll', updateVisibility, { passive: true });
    updateVisibility();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canine-modern-home"] && !Shopify.designMode) return;
  try {
    
  const initialiseHomeVideos = (root) => {
    root.querySelectorAll('.cc-home__hero-video, .cc-home__service-video').forEach((video) => {
      if (video.dataset.autoplayReady === 'true') return;

      video.dataset.autoplayReady = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;

      const playVideo = () => {
        const playback = video.play();
        if (playback) playback.catch(() => {});
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            playVideo();
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.15 });

      observer.observe(video);

      if (video.readyState >= 2) {
        playVideo();
      } else {
        video.addEventListener('canplay', playVideo, { once: true });
      }
    });
  };

  const startHomeVideos = () => initialiseHomeVideos(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startHomeVideos, { once: true });
  } else {
    startHomeVideos();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseHomeVideos(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canine-review-carousel"] && !Shopify.designMode) return;
  try {
    
  const initialiseReviewCarousels = (root) => {
    root.querySelectorAll('.cc-review-grid').forEach((section) => {
      if (section.dataset.carouselReady) return;
      const track = section.querySelector('.cc-review-grid__cards');
      const cards = [...track.querySelectorAll('.cc-review-grid__card')];
      const controls = section.querySelector('.cc-review-grid__controls');
      if (!cards.length) return;
      section.dataset.carouselReady = 'true';
      const previous = controls.querySelector('[data-review-direction="previous"]');
      const next = controls.querySelector('[data-review-direction="next"]');
      const position = controls.querySelector('.cc-review-grid__position');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => {
        const bounds = track.getBoundingClientRect();
        const visible = cards.map((card, index) => ({ index, bounds: card.getBoundingClientRect() }))
          .filter((card) => card.bounds.left >= bounds.left - 2 && card.bounds.right <= bounds.right + 2);
        const first = visible[0]?.index ?? 0;
        const last = visible[visible.length - 1]?.index ?? first;
        position.textContent = (first === last ? first + 1 : (first + 1) + '–' + (last + 1)) + ' ' + position.dataset.reviewOf + ' ' + cards.length;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        controls.hidden = track.scrollWidth <= track.clientWidth + 2;
      };
      controls.addEventListener('click', (event) => {
        const button = event.target.closest('[data-review-direction]');
        if (!button || button.disabled) return;
        const step = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        track.scrollBy({ left: button.dataset.reviewDirection === 'next' ? step : -step, behavior: motion.matches ? 'instant' : 'smooth' });
      });
      let frame;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      }, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseReviewCarousels(document), { once: true });
  } else {
    initialiseReviewCarousels(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialiseReviewCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canine-theme-styles"]) return;
  try {
    
  document.querySelectorAll('.header-wrapper a[href^="https://the-canine-clinic.uk1.cliniko.com/bookings"], .menu-drawer a[href^="https://the-canine-clinic.uk1.cliniko.com/bookings"]').forEach(function(link) {
    link.href = '/pages/online-booking';
  });

  document.querySelectorAll('#HeaderMenu-for-vets, #HeaderDrawer-for-vets, .header-wrapper a[href^="https://cmrs63pytqr.typeform.com/to/ToMipDsE"], .menu-drawer a[href^="https://cmrs63pytqr.typeform.com/to/ToMipDsE"]').forEach(function(link) {
    link.href = '/pages/for-vets';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const accordions = document.querySelectorAll('footer.cc-footer-minimal .cc-footer-accordion');
    if (!accordions.length) return;

    const mobile = window.matchMedia('(max-width: 749px)');
    const syncAccordions = (event) => {
      accordions.forEach((accordion) => {
        if (event.matches) {
          accordion.removeAttribute('open');
        } else {
          accordion.setAttribute('open', '');
        }
      });
    };

    syncAccordions(mobile);
    mobile.addEventListener('change', syncAccordions);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
